import { AlertMessagesService } from '../../../../shared';

const currencySymbol = '$';

export const defaultColDef = {
    flex: 5,
    filter: true,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    minWidth: 150,
    floatingFilter: true,
    suppressHeaderMenuButton: true,
};

export const columnDefs = [
    {
        headerName: "PLACEMENT NAME",
        field: "placement_taxonomy",
        wrapText: true,
        autoHeight: true,
        width: 900,
        flex: null,
        showRowGroup: true,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        cellRenderer: 'agGroupCellRenderer',
        // Remove the custom TaxonomyRenderer and use default rendering
        cellRendererParams: {
            suppressCount: true,
            // innerRenderer: this.placementNameRenderer,
        },
        cellStyle: params => {
            return { left: 0 };
        }
    },
    {
        headerName: "PLACEMENT TYPE",
        field: "package_type",
        resizable: true,
        width: 200,
        wrapText: true,
        autoHeight: true,
        flex: null,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "PLANNED NET MEDIA",
        field: "publisher_budget_in_pmds",
        resizable: true,
        width: 100,
        wrapText: true,
        autoHeight: true,
        editable: false,
        valueFormatter: (params) => params.value ? `${currencySymbol} ${params.value}` : '',
        cellEditor: "agNumberCellEditor",
        flex: null,
        filter: "agNumberColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "NET MEDIA",
        field: "planned_cost",
        resizable: true,
        width: 175,
        wrapText: true,
        autoHeight: true,
        editable: (params) => {
            const title = params?.data?.title;
            return title ? !['Publisher', 'Channel'].includes(title) : true;
        },
        valueFormatter: (params) => params.value ? `${currencySymbol} ${params.value}` : '',
        cellEditor: "agNumberCellEditor",
        flex: null,
        filter: "agNumberColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "RATE",
        field: "rate",
        resizable: true,
        width: 175,
        wrapText: true,
        autoHeight: true,
        editable: (params) => {
            const title = params?.data?.title;
            return title ? !['Publisher', 'Channel'].includes(title) : true;
        },
        valueFormatter: (params) => params.value ? `${currencySymbol} ${params.value}` : '',
        cellEditor: "agNumberCellEditor",
        flex: null,
        filter: "agNumberColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "UNITS",
        field: "unit_amount",
        resizable: true,
        width: 100,
        wrapText: true,
        autoHeight: true,
        editable: (params) => {
            const title = params?.data?.title;
            return title ? !['Publisher', 'Channel'].includes(title) : true;
        },
        cellEditor: "agNumberCellEditor",
        flex: null,
        filter: "agNumberColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "AD SERVING",
        field: "ad_server_fee",
        resizable: true,
        width: 100,
        wrapText: true,
        autoHeight: true,
        editable: false,
        valueFormatter: (params) => params.value ? `${currencySymbol} ${params.value}` : '',
        cellEditor: "agNumberCellEditor",
        flex: null,
        filter: "agNumberColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        hide: true
    },
    {
        headerName: "AD VERIFICATION",
        field: "ad_verification_fee",
        resizable: true,
        width: 100,
        wrapText: true,
        autoHeight: true,
        editable: false,
        valueFormatter: (params) => params.value ? `${currencySymbol} ${params.value}` : '',
        cellEditor: "agNumberCellEditor",
        flex: null,
        filter: "agNumberColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        hide: true
    },
    {
        headerName: "TOTAL MEDIA",
        field: "planned_cost",
        resizable: true,
        width: 100,
        wrapText: true,
        autoHeight: true,
        editable: false,
        valueFormatter: (params) => params.value ? `${currencySymbol} ${params.value}` : '',
        cellEditor: "agNumberCellEditor",
        flex: null,
        filter: "agNumberColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "START DATE",
        field: "flight_start",
        resizable: true,
        width: 225,
        wrapText: true,
        autoHeight: true,
        flex: null,
        filter: "agDateColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        cellEditor: 'agDateCellEditor',
        editable: (params) => {
            const title = params?.data?.title;
            return title ? !['Publisher', 'Channel'].includes(title) : true;
        },
        valueFormatter: (params) => {
            if (!params.value) {
                return "";
            }
            const month = params.value.getMonth() + 1;
            const day = params.value.getDate();
            return `${params.value.getFullYear()}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
        },
    },
    {
        headerName: "END DATE",
        field: "flight_end",
        resizable: true,
        width: 225,
        wrapText: true,
        autoHeight: true,
        flex: null,
        filter: "agDateColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        cellEditor: 'agDateCellEditor',
        editable: (params) => {
            const title = params?.data?.title;
            return title ? !['Publisher', 'Channel'].includes(title) : true;
        },
        valueFormatter: (params) => {
            if (!params.value) {
                return "";
            }

            const date = new Date(params.value);
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${date.getFullYear()}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
        },
    },
    {
        headerName: "PARAMETER CODE",
        field: "parameter_code",
        width: 900,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: null,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "MODIFIED BY",
        field: "updated_by",
        resizable: true,
        width: 300,
        wrapText: true,
        autoHeight: true,
        flex: null,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "MODIFIED DATE",
        field: "updated_at",
        resizable: true,
        width: 200,
        wrapText: true,
        autoHeight: true,
        flex: null,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        cellEditor: 'agDateCellEditor',
        editable: false,
        valueFormatter: (params) => {
            if (!params.value) {
                return "";
            }

            const date = new Date(params.value);
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${date.getFullYear()}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
        },
    },
    {
        headerName: "TAXONOMY STATUS",
        field: "taxonomy_status",
        width: 175,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: null,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "MOH STATUS",
        field: "mediaopshub_status",
        width: 175,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: null,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
    },
    {
        headerName: "MEDIAOCEAN STATUS",
        field: "mediaocean_status",
        width: 175,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: null,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        pinned: 'right',
        tooltipValueGetter: ({ data }) => {
            if(['export error', 'import error'].includes(data.mediaocean_status?.toLowerCase())) {
                return data.error_description ? data.error_description : null;
            }
            return null;
        }
    },
    {
        headerName: "ACTIONS",
        field: "actions",
        width: 160,
        sortable: false,
        filter: false,
        pinned: 'right',
        flex: null,
        floatingFilter: false,
        suppressHeaderMenuButton: true,
        "cellStyle": { "overflow": "visible" },
    }
];

// Context menu array for the Placement AG-Grid Table
export const contextMenuItems = () => {
    return [
        {
            name: 'Copy',
            shortcut: "Ctrl + C",
            action: (data) => {
                data.api.copyToClipboard(data.value);
                AlertMessagesService.showInfoToastMessage('Selected value has been copied to clipboard');
            },
            icon: '<span class="ag-icon ag-icon-copy" unselectable="on" role="presentation"></span>',
        },
    ];
}
